import {
  downloadIcsEvent,
  serializeIcsEvent,
  type CalendarDateInput,
} from "../../../utils/calendarEventExport";

export interface ParentMeetingCalendarItem {
  slotId: string;
  title: string;
  startsAt: CalendarDateInput;
  endsAt: CalendarDateInput;
  description?: string | null;
}

const parentMeetingIcsOptions = {
  productId: "-//Lumen//Parent Meeting//NL",
  method: "PUBLISH",
};

const toCalendarEvent = (item: ParentMeetingCalendarItem) => ({
  uid: `parent-meeting-${item.slotId}@lumen`,
  title: item.title,
  startsAt: item.startsAt,
  endsAt: item.endsAt,
  description: item.description,
});

export const buildParentMeetingIcs = (
  item: ParentMeetingCalendarItem,
  timestamp?: CalendarDateInput,
) => serializeIcsEvent(toCalendarEvent(item), {
  ...parentMeetingIcsOptions,
  timestamp,
});

export const downloadParentMeetingIcs = (item: ParentMeetingCalendarItem) => {
  downloadIcsEvent(
    toCalendarEvent(item),
    `parent-meeting-${item.slotId}.ics`,
    parentMeetingIcsOptions,
  );
};
